import { AvailableColumn } from "../models/AvailableColumn";
import { Rule } from "../models/Rule";
import { SchemaVersion, SchemaVersionedService } from "./SchemaVersionedService";


export abstract class AvailableColumnServiceBase extends SchemaVersionedService {

    public static readonly serviceKeyPrefix: string = "AvailableColumnService";

    constructor(version: SchemaVersion) {
        super(version)
    }

    public getAvailableColumnsForRule(rule: Rule | null, allRules: Array<Rule>, sourceAvailableColumns: Array<AvailableColumn>): Array<AvailableColumn> {

        if (allRules == null) throw Error("allRules is required");
        if (rule == null) return sourceAvailableColumns;

        let availableColumns = [...sourceAvailableColumns || []];

        availableColumns = this.calculateAvailableColumnsForRule(rule, allRules, availableColumns);

        // sort alphanumerically by label if present, otherwise by value (natural numeric-aware ordering)
        const keyFor = (c: AvailableColumn) => String((c?.label ?? c?.value ?? '')).trim();
        availableColumns.sort((a, b) =>
            keyFor(a).localeCompare(keyFor(b), undefined, { numeric: true, sensitivity: 'base' })
        );

        return availableColumns;

    }

    protected abstract calculateAvailableColumnsForRule(rule: Rule, rules: Array<Rule>, availableColumns: Array<AvailableColumn>): Array<AvailableColumn>;


}
